import { SUPPORTED_AWARDS as SHARED_SUPPORTED_AWARDS } from '../../shared/awards'

// Single-source default Award code — the fallback used when an org has no
// defaultAwardCode set on its organisations doc (pre-MA000119 orgs, or any
// write path that hasn't resolved a real org-level value yet). Defaulting
// awardCode at every wageConfig creation/apply site closes a live bug found
// 2026-07-27: nothing ever actually SET wageConfig.awardCode when a wage
// profile was created via WageProfiles.vue (no UI field for it, no default)
// or applied to a person (ViewPeople.vue's handleApplyProfile just copied
// the profile's — also empty — awardCode straight through).
// functions/index.js's computeAwardMinimumValidation treats a falsy
// awardCode as "nothing to validate" and never even queries — a fully and
// correctly classified casual profile (base rate, stream, classification, 6
// penalty rules) still resolved to 'unvalidated' because this one field was
// silently blank.
//
// Defaulting awardCode alone is safe: it does NOT cause a false compliant/
// below_minimum result on its own — stream and classificationLevel remain
// genuinely optional and gate the actual Firestore query
// (functions/index.js:5899/6385) independently. A profile with no
// stream/classification picked still correctly resolves to unvalidated.
//
// MA000119 (Restaurant Industry Award) is now supported alongside MA000009
// (Hospitality Industry General Award) — see SUPPORTED_AWARDS below. Each
// org picks its own award via organisations/{orgId}.defaultAwardCode
// (Setup.vue / OrgSettings.vue); this constant is ONLY the fallback for an
// org that has never set that field (every org created before this feature
// shipped) — call sites should prefer the org's own value and fall back to
// this, not read this constant directly. See src/stores/token.js's
// `defaultAwardCode` state (populated from the org doc at login) for the
// resolved per-org value.
export const DEFAULT_AWARD_CODE = 'MA000009';

// The awards Rosterem has ingested minimum-rate + preset data for. Each
// entry's `code` matches awardMinimumRates docs' awardCode field and the
// preset builder module named `{code-lowercase}Presets.js`. Plain-language
// description text is shown in the Setup wizard / OrgSettings picker — not
// legal advice, hence the FWO Award Finder link alongside it.
// ⚠ MOVED, NOT COPIED. The list itself is `shared/awards`, because
// `shared/xero-rule-rows`' label ladder needs an award's venue-facing short
// name and `shared/` cannot import from `src/`. This is a RE-EXPORT so the four
// call sites here keep their import unchanged; there is no second list.
export const SUPPORTED_AWARDS = SHARED_SUPPORTED_AWARDS;

// Not every venue fits neatly into one of the two descriptions above —
// linked directly in the picker rather than us attempting to adjudicate
// edge cases (e.g. a cafe inside a hotel) that are genuinely a legal
// classification question, not a UI one.
export const FWO_AWARD_FINDER_URL = 'https://www.fairwork.gov.au/employment-conditions/awards/find-my-award';
